import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/HomeView'
import Portfolio from '@/views/PortfolioView'
import Contact from '@/views/ContactView'
import Curriculum from "@/views/CurriculumView"
import PageNotFound from "@/views/PageNotFound"

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/portfolio',
		name: 'Portfolio',
		component: Portfolio
	},
	{
		path: '/contact',
		name: 'Contact',
		component: Contact
	},
	{
		path: '/curriculum',
		name: 'Curriculum',
		component: Curriculum
	},
	{
		path:"/:pathMatch(.*)*",
		name: "pageNotFound",
		component: PageNotFound
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, _, next) => {
	const ROUTE_DOCUMENT_TITLES = {
		Home: "JaviCo",
		Portfolio: "JaviCo - Portfolio",
		Contact: "JaviCo - Contact",
		Curriculum: "JaviCo - Curriculum",
		pageNotFound: "JaviCo - Page Not Found"
	}
	
	document.title = ROUTE_DOCUMENT_TITLES[to.name]
	next()
})

export default router